import * as actions from './actions';
import * as selectors from './selectors';

import reducers from './reducers';

const bom = { actions, reducers, selectors };
export default bom;
